import { useCallback, useRef, useState } from 'react';
import { Segment, SegmentRefs } from '../types';

export function useDateNavigation() {
  const [focusedSegment, setFocusedSegment] = useState<Segment | null>(null);

  const yearRef = useRef<HTMLInputElement>(null);
  const monthRef = useRef<HTMLInputElement>(null);
  const dayRef = useRef<HTMLInputElement>(null);

  const refs: SegmentRefs = {
    year: yearRef,
    month: monthRef,
    day: dayRef,
  };

  const focusSegment = useCallback((segment: Segment) => {
    setFocusedSegment(segment);
    refs[segment].current?.focus();
  }, []);

  const blurSegment = useCallback(() => {
    setFocusedSegment(null);
  }, []);

  return {
    focusedSegment,
    setFocusedSegment,
    refs,
    focusSegment,
    blurSegment,
  };
}
